import {BookedSeat, DrawingItemsTypes, IDrawingItem, ISeatItemProps, Seat} from "@/app/dashboard/models/Seating";
import {computed, signal} from "@preact/signals-react";
import {getSeatingByEventId} from "@/services/event-tickets-service";
import {eventInSingleEventPage} from "@/app/events/store/single-page.store";
import {showCommonApiError} from "@/lib/toast-utill";
import {decreaseQuantity, increaseQuantity} from "@/app/events/[id]/store/buy-tickets.store";
import {SeatingOrderItem} from "@/app/dashboard/models/EventTicketCategory";

export const seatingItemGroups = signal<IDrawingItem<ISeatItemProps>[]>([]);
export const allSeats = computed(()=>seatingItemGroups.value.filter(s => s.type === DrawingItemsTypes.SEAT_GROUP)
    .map( s => s.data.seats).flat())


export const bookedSeats = signal<BookedSeat[]>([])


export const selectedSeatCount = computed(()=>allSeats.value.filter(s => s.isSelected).length);

export const selectedSeats = computed<SeatingOrderItem[]>(() => {
    return seatingItemGroups.value.filter(s => s.type === DrawingItemsTypes.SEAT_GROUP)
        .map( s => {
            const selectedSeats = s.data.seats.filter(s => s.isSelected);
            return selectedSeats.map(seat => ({
                seatNumber: seat.seatNumber,
                ticketCategoryId: seat.ticketCategoryId,
                drawingItemId: s.id,
            }))

        }).flat()
});


export const selectSeatItem = (item:Seat) => {
    if(!item.isSelected){
        const updatedSeats = seatingItemGroups.value.map((groupItem) => {
            const seats = groupItem?.data?.seats?.map(s => {
                if(s.seatNumber === item.seatNumber && s.ticketCategoryId) {
                    increaseQuantity(s.ticketCategoryId)
                    return {...s, isSelected: true};
                }
                return s
            });
            return {
                ...groupItem,
                data: {
                    ...groupItem.data,
                    seats
                }
            };
        })
        seatingItemGroups.value = [...updatedSeats];
    }
}

export const deSelectSeatItem = (item:Seat) => {
    if(item.isSelected){
        const updatedSeats = seatingItemGroups.value.map((groupItem) => {
            const seats = groupItem?.data?.seats?.map(s => {
                if(s.seatNumber === item.seatNumber && s.ticketCategoryId) {
                    decreaseQuantity(s.ticketCategoryId);
                    return {...s, isSelected: false};
                }
                return s
            });
            return {
                ...groupItem,
                data: {
                    ...groupItem.data,
                    seats
                }
            };
        })
        seatingItemGroups.value = [...updatedSeats];
    }
}


export const loadSeatingItems = async () => {
    const [data, error] = await getSeatingByEventId(eventInSingleEventPage.value.id);
    if (error) {
        showCommonApiError("while loading seating items");
        return;
    }
    seatingItemGroups.value = data.seatArrangement.levels[0].sections[0].seatingAreas;
    bookedSeats.value = data.bookedSeats;

}